import { styled } from '../../../stitches.config';

export const ContentWrapper = styled('div', {
  maxWidth: '86rem',
  margin: '0 auto',
  padding: '0 $7',
});

export const ContentSpacer = styled('div', {
  marginLeft: '3rem',
  marginRight: '5.4rem',
});
